import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistES() {
  const articleData = {
    title: '¿Es tu ex un narcisista encubierto? (Los textos no mienten)',
    description: '¿Te preguntas si tu ex es un narcisista encubierto? Descubre 7 comportamientos manipuladores sutiles que nuestra IA detecta al instante en mensajes de texto.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Toxic Detector Editorial'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: '¿Qué es un narcisista encubierto y cómo se diferencia de los narcisistas abiertos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Los narcisistas encubiertos ocultan sus comportamientos manipuladores detrás de encanto, tácticas emocionales sutiles y mensajes pasivo-agresivos, a diferencia de los narcisistas obvios y abiertos.'
      }
    }, {
      '@type': 'Question',
      name: '¿Puede la IA detectar el narcisismo encubierto en mensajes de texto?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sí. Toxic Detector analiza el tono, la culpa, los ciclos de love-bombing, la inconsistencia y los patrones de manipulación emocional para marcar el comportamiento narcisista encubierto.'
      }
    }, {
      '@type': 'Question',
      name: '¿Cuáles son los comportamientos comunes de los narcisistas encubiertos en textos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Manipulación emocional, gaslighting, comentarios pasivo-agresivos, hacerse la víctima, love-bombing seguido de retiro y control sutil.'
      }
    }, {
      '@type': 'Question',
      name: '¿Cómo puedo protegerme de un narcisista encubierto?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Documenta los mensajes, confía en tus instintos, mantén límites y usa herramientas como Toxic Detector para identificar objetivamente patrones manipuladores.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      url: 'https://toxicdetector.com/'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      url: 'https://toxicdetector.com/'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('¡Enlace copiado al portapapeles!');
    }
  };
  return <>
      <MetaTags title="¿Es tu ex un narcisista encubierto? Cómo la IA detecta manipulación | ToxicDetector" description="¿Te preguntas si tu ex es un narcisista encubierto? Descubre 7 comportamientos manipuladores sutiles que nuestra IA detecta al instante." keywords="señales narcisista encubierto, comportamiento narcisista oculto, manipulación narcisista textos, detector narcisista IA" canonical={`https://toxicdetector.com/es/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-4947" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-4948">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-4949">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-4950">
            <div className="flex items-center justify-between" data-id="element-4951">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-4952">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Compartir artículo" data-id="element-4953">
                <Share2 size={20} className="text-gray-600" data-id="element-4954" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-4955">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-4956">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-4957" />
            Volver al Blog
          </Link>

          <header className="mb-12" data-id="element-4958">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-4959">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-4960">
              <time dateTime={articleData.publishDate} data-id="element-4961">
                {new Date(articleData.publishDate).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-4962">•</span>
              <span data-id="element-4963">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-4964">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Mujer analizando mensajes de texto en busca de señales de manipulación narcisista encubierta con IA" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-4965" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-4966">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-4967">
              Tabla de Contenidos
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-4968">
              <li data-id="element-4969">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4970">
                  <span className="text-gray-400" data-id="element-4971">→</span> 1. Manipulación
                  emocional en cada mensaje
                </a>
              </li>
              <li data-id="element-4972">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4973">
                  <span className="text-gray-400" data-id="element-4974">→</span> 2. Gaslighting que se
                  acumula lentamente
                </a>
              </li>
              <li data-id="element-4975">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4976">
                  <span className="text-gray-400" data-id="element-4977">→</span> 3. Comentarios
                  pasivo-agresivos
                </a>
              </li>
              <li data-id="element-4978">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4979">
                  <span className="text-gray-400" data-id="element-4980">→</span> 4. Hacerse la víctima
                  constantemente
                </a>
              </li>
              <li data-id="element-4981">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4982">
                  <span className="text-gray-400" data-id="element-4983">→</span> 5. Love-Bombing y
                  luego retiro
                </a>
              </li>
              <li data-id="element-4984">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4985">
                  <span className="text-gray-400" data-id="element-4986">→</span> 6. Control oculto y
                  monitoreo
                </a>
              </li>
              <li data-id="element-4987">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-4988">
                  <span className="text-gray-400" data-id="element-4989">→</span> 7. Tono inconsistente
                  entre canales
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-4990">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-4991">
              ¿Alguna vez has sentido que tu ex te manipulaba tras bambalinas,
              mientras parecía encantador y cariñoso? Esas son{' '}
              <strong data-id="element-4992">señales clásicas de un narcisista encubierto</strong>. A
              diferencia de los narcisistas obvios, los encubiertos ocultan su
              manipulación detrás de tácticas emocionales sutiles.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-4993">
              Nuestra <strong data-id="element-4994">IA detecta manipulación oculta</strong> al
              instante analizando sus textos. Así es como.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-4995">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-4996">
                1️⃣ Manipulación emocional en cada mensaje
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-4997">
                Los narcisistas encubiertos tuercen las emociones para salirse
                con la suya.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-4998">
                <p className="italic text-gray-700 text-lg" data-id="element-4999">
                  "No puedo creer que te molestes por esto..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5000">
                La IA detecta culpa sutil y presión emocional oculta en mensajes
                cotidianos.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-5001">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5002">
                2️⃣ Gaslighting que se acumula lentamente
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5003">
                <p className="italic text-gray-700 text-lg" data-id="element-5004">
                  "Estás recordando eso mal..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5005">
                Los narcisistas encubiertos te hacen dudar de tu propia memoria.
                La IA marca instancias repetidas donde la realidad está siendo
                distorsionada.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-5006">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5007">
                3️⃣ Comentarios pasivo-agresivos
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5008">
                <p className="italic text-gray-700 text-lg" data-id="element-5009">
                  "Seguro, lo que te haga feliz..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5010">
                La agresión pasiva es un sello distintivo del narcisismo
                encubierto. La IA reconoce el sarcasmo, las indirectas y la
                hostilidad enmascarada.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-5011">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5012">
                4️⃣ Hacerse la víctima constantemente
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5013">
                <p className="italic text-gray-700 text-lg" data-id="element-5014">
                  "Después de todo lo que he hecho por ti..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5015">
                Los narcisistas encubiertos a menudo voltean la culpa,
                haciéndose las víctimas. La IA detecta frases diseñadas para
                culparte.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-5016">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5017">
                5️⃣ Love-Bombing y luego retiro
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5018">
                <p className="italic text-gray-700 text-lg" data-id="element-5019">
                  "Eres la única persona que he amado 😢" → ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5020">
                Este ciclo clásico de afecto intenso seguido de distancia
                emocional es una señal de alerta. La IA identifica estos
                patrones a través de múltiples chats.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-5021">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5022">
                6️⃣ Control oculto y monitoreo
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5023">
                <p className="italic text-gray-700 text-lg" data-id="element-5024">
                  "Solo revisando... otra vez"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5025">
                El control sutil disfrazado de cuidado es una táctica
                encubierta. La IA marca el comportamiento de control repetido
                sin agresión abierta.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-5026">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5027">
                7️⃣ Tono inconsistente entre canales
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5028">
                <p className="italic text-gray-700 text-lg" data-id="element-5029">
                  Chat grupal: juguetón / 1:1: crítico
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5030">
                Los narcisistas encubiertos a menudo enmascaran su
                comportamiento públicamente mientras manipulan en privado. La IA
                compara conversaciones para resaltar discrepancias.
              </p>
            </section>

            <section className="mb-12" data-id="element-5031">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5032">
                🛡 Cómo protegerte
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-5033">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-5034">
                  <li className="flex items-start gap-3" data-id="element-5035">
                    <span className="text-purple-600 font-bold" data-id="element-5036">•</span>
                    <span data-id="element-5037">
                      Confía en tus instintos. No ignores las señales de alerta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5038">
                    <span className="text-purple-600 font-bold" data-id="element-5039">•</span>
                    <span data-id="element-5040">
                      Guarda capturas de pantalla para mayor claridad.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5041">
                    <span className="text-purple-600 font-bold" data-id="element-5042">•</span>
                    <span data-id="element-5043">
                      Comparte tu experiencia con amigos o un terapeuta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5044">
                    <span className="text-purple-600 font-bold" data-id="element-5045">•</span>
                    <span data-id="element-5046">
                      Usa herramientas como Toxic Detector para identificar
                      patrones.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-5047">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5048">
                💀 Míralo con tus propios ojos
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5049">
                El narcisismo encubierto puede ser difícil de detectar, pero la
                IA no pierde detalle. Sube tus chats y obtén un análisis
                instantáneo:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-5050">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-5051">
                  "🚩 78% manipulación detectada. ¡Tácticas encubiertas
                  identificadas!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-5052">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5053">
                Preguntas Frecuentes
              </h2>
              <div className="space-y-4" data-id="element-5054">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-5055">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-5056">
                      <span data-id="element-5057">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-5058" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-5059">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-5060">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-5061">
              💀 ¿Listo para descubrir la verdad?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-5062">
              Deja de adivinar. Sube tus textos a Toxic Detector y obtén una
              puntuación de toxicidad instantánea. Nuestra IA revela la
              manipulación encubierta que podrías haber pasado por alto.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-5063">
              <p className="font-bold text-xl" data-id="element-5064">
                "🚩 78% manipulación detectada. ¡Tácticas encubiertas
                identificadas!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-5065">
              Escanea tus chats ahora →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Señales de Gaslighting que Nuestra IA Detecta al Instante',
          description: 'Aprende los patrones clave de gaslighting que la IA detecta en tus conversaciones de texto.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'La Guía Definitiva de Textos Pasivo-Agresivos',
          description: 'Detecta el comportamiento pasivo-agresivo y la manipulación oculta en mensajes de texto.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-5066" />

          <div className="mt-12 text-center" data-id="element-5067">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-5068">
              <Share2 size={18} className="mr-2" data-id="element-5069" />
              Compartir este artículo
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-5070">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-5071">
            <p className="text-gray-500 text-sm" data-id="element-5072">
              © {new Date().getFullYear()} ToxicDetector. Todos los derechos
              reservados.
            </p>
          </div>
        </footer>
      </div>
    </>;
}